import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';

export class WorkspaceCompany {
  constructor(
    public readonly ownerId: number,
    public readonly investmentStrategy: Nullable<string>,
    public readonly signupReason: Nullable<string>,
  ) {}
}

defineTransform(WorkspaceCompany, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
  };
});
